import { Component } from '@angular/core';
import { PrimeNGButtonOpenItemViewActionComponent } from '@ntap/primeng';
import { map } from 'rxjs';

@Component({
  selector: 'app-open-vezano-gradivo-osobe-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class OpenVezanoGradivoOsobeActionComponent extends PrimeNGButtonOpenItemViewActionComponent {
  protected override initDisabledObservable(): void {
    super.initDisabledObservable();
    this.isDisabled$ = this.itemProvider.item$.pipe(
      map((item: any) => {
        return item['$disableActions'];
      })
    );
  }
}
